nn.component.ExternalLink = function (element) {
  this.element = $(element);
  this.element.attr('target', '_blank');
  this.element.click (function (e) {
    if ($(this).attr('href') === '#') {
      e.preventDefault();
    }
  })
}